import { render, staticRenderFns } from "./addDeviceSwitch.vue?vue&type=template&id=ca52295a&scoped=true"
import script from "./addDeviceSwitch.vue?vue&type=script&lang=js"
export * from "./addDeviceSwitch.vue?vue&type=script&lang=js"
import style0 from "./addDeviceSwitch.vue?vue&type=style&index=0&id=ca52295a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca52295a",
  null
  
)

export default component.exports